import Icon from "@mui/icons-material/EditLocationAlt";
import ItsdataAddressChangeQueueList from "./ItsdataAddressChangeQueueList";

export default {
  list: ItsdataAddressChangeQueueList,
  icon: Icon,
  label: "ITS address updates",
  options: { label: "ITS address updates" },
  name: "itsdataAddressChangeQueue",
};
